import { render, staticRenderFns } from "./LeftArea.vue?vue&type=template&id=1f1ad547&scoped=true"
import script from "./LeftArea.vue?vue&type=script&lang=js"
export * from "./LeftArea.vue?vue&type=script&lang=js"
import style0 from "./LeftArea.vue?vue&type=style&index=0&id=1f1ad547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ad547",
  null
  
)

export default component.exports